export default __webpack_public_path__ + "static/facilities001_300x200-ff99b415ba793009e94467cf160d0397.jpg";